<template>
  <main class="main">
    <div class="container fluid">
      <section class="row registration my-0">
        <div class="col-lg-6 col-md-12 registration__left">
          <h2 class="registration__title">Payment information</h2>
          <form class="registration__form" autocomplete="off">
            <div class="mb-3">
              <input v-model="paymentInfo.firstName" type="text" :class="{ registration__input_error: nameErrorMessage }"
                @input="validateName" placeholder="Williams Morris" class="w-100"/>
                <span v-if="nameErrorMessage" class="small mt-1 text-danger">{{ nameErrorMessage }}</span>
            </div>
            <input v-model="paymentInfo.phone" class="col-12 registration__input"
              :class="{ registration__input_error: errorMessage }" type="tel" placeholder="Number with full format"
              @input="validatePhone" />
            <input v-model="paymentInfo.email" class="col-12 registration__input" type="email"
              placeholder="Email address *" />
            <div class="registration__checkbox">
              <input type="checkbox" id="check" v-model="deliveryEnabled" />
              <label for="check" class="mb-0">Enter delivery address</label>
            </div>
            <div v-if="deliveryEnabled" class="registration__delivery-info">
              <label for="country" class="d-flex flex-column mb-2">
                <p class="mb-1">
                  <span class="delivery-info__input-label">Country</span>
                  <span class="delivery-info__input-required-sign">*</span>
                </p>
                <!-- <input
                  v-model="deliveryInfo.country"
                  id="country"
                  type="text"
                  placeholder="Страна"
                /> -->
                <v-autocomplete id="country" item-value="id" item-text="country" :items="countriesList"
                  class="ma-0 pa-0" @change="getDeliveryPrice()" v-model="deliveryInfo.country"></v-autocomplete>
              </label>
              <label for="address" class="d-flex flex-column mb-2">
                <p class="mb-1">
                  <span class="delivery-info__input-label">Address</span>
                  <span class="delivery-info__input-required-sign">*</span>
                </p>
                <input v-model="deliveryInfo.address" id="address" type="text"
                  placeholder="House number and street name" />
              </label>
              <!-- <label for="living-area" class="d-flex flex-column mb-2">
                <p class="mb-1">
                  <span class="delivery-info__input-label">Address 2</span>
                  <span class="delivery-info__input-required-sign">*</span>
                </p>
                <input
                  v-model="deliveryInfo.livingArea"
                  id="living-area"
                  type="text"
                />
              </label> -->
              <label for="district" class="d-flex flex-column mb-2">
                <p class="mb-1">
                  <span class="delivery-info__input-label">Area/region</span>
                  <span class="delivery-info__input-required-sign">*</span>
                </p>
                <input v-model="deliveryInfo.district" id="district" type="text" />
              </label>
              <label for="mail-index" class="d-flex flex-column mb-2">
                <p class="mb-1">
                  <span class="delivery-info__input-label">Postal code</span>
                  <span class="delivery-info__input-required-sign">*</span>
                </p>
                <input v-model="deliveryInfo.mailIndex" id="mail-index" type="text" />
              </label>
              <label v-if="additionalField" for="inn" class="d-flex flex-column mb-2">
                <p class="mb-1">
                  <span class="delivery-info__input-label">INN</span>
                  <span class="delivery-info__input-required-sign">*</span>
                </p>
                <!-- v-model="deliveryInfo.inn" -->
                <input id="inn" type="number" maxlength="12" v-model="deliveryInfo.inn" @input="innInput" />
              </label>
            </div>
          </form>
        </div>
        <div class="col-lg-6 col-md-12 registration__right">
          <h2 class="registration__title">Your order</h2>
          <div class="registration__payment">
            <!-- <h3>If you have a coupon code, please apply it below</h3>
            <input class="payment__promocode" type="text" placeholder="Have a promocode / dicount card number?" />
            <button class="payment__btn">Apply coupon</button> -->
            <v-expansion-panels class="mb-1" flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="payment__product mb-0">
                  <span>Product</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <template v-if="isSpecialProduct">
                    <div v-for="(item, i) in order" :key="i" class="payment__goods px-0">
                      <span>{{ item.product.name.ru }} × {{ item.count }}</span>
                      <span class="price">{{ item.product.sale_cost }} KGS</span>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="item in order" :key="item.cartId" class="payment__goods px-0">
                      <span>{{ item?.product.name.ru }} ×
                        {{ item?.size?.count }}</span>
                      <span class="price">
                        {{

                          item?.size?.price?.discount?.discounts[0]
                            ?.value ?
                            Math.ceil(
                              item?.size?.price?.view -
                              (item?.size?.price?.view *
                                item?.size?.price?.discount?.discounts[0]
                                  ?.value) /
                              100
                            ) : item?.size?.price?.view

                        }}
                      </span>
                    </div>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div class="payment__total-wrapper">
            </div>
            <div v-if="deliveryPrice" :class="deliveryPrice.cost ? '' : 'd-block'" class="payment__total">
              <span>Delivery</span>
              <template v-if="deliveryPrice && deliveryPrice.cost">
                <span class="total notranslate">
                  <span class="total notranslate">
                    {{ Number(deliveryPrice.cost.delivery_view) }}
                  </span>
                  <span class="total">
                    <span>{{ deliveryPrice.currency.code
                      ? deliveryPrice.currency.code : (isSpecialProduct ? 'KGS' :
                        order[0]?.size?.currency.currency.currency) }}</span>
                  </span>
                </span>
              </template>
              <template v-else>
                <ul class="p-0">
                  <li v-for="service in deliveryPrice.services" :key="service.id" class="mt-4">
                    <label class="d-flex align-items-center justify-content-between">
                      <span>
                        <input v-model="selectedDeliveryService" :value="service.id" type="radio"
                          name="delivery_service" class="me-3" />
                        <span>{{ service.title }}</span>
                      </span>
                      <span>
                        <span class="fs-4">{{ service.price }}</span>
                        <span class="fs-6">{{ deliveryPrice.currency.code }}</span>
                      </span>
                    </label>
                  </li>
                </ul>
              </template>
            </div>
            <div class="payment__total">
              <span>Total</span>
              <span class="total notranslate">
                <span class="total notranslate">{{ subtotal }}</span>
                <span class="total">
                  {{
                    isSpecialProduct
                      ? 'KGS'
                      : order[0]?.size?.currency.currency.currency
                  }}
                </span>
              </span>
            </div>
            <div class="payment__method">
              <div v-for="item in paymentMethods" :key="item.value" class="payment_option"
                :class="selectedPayment === item.value ? 'payment_option_active' : ''"
                @click="selectedPayment = item.value">
                <img :src="item.image" :class="item.class" :alt="getImageName(item.image)"
                  :title="getImageName(item.image)" />
              </div>
            </div>
            <div class="payment__note">
              <p>По законодательству Кыргызсткой Республики мы имеем право взимать оплату только в валюте сом. </p>
            </div>
            <p class="payment__text">
              By placing an order, you accept our rules,
              <a href="/pages/Privacy-Policy">privacy policy</a> and
              <a href="/pages/returns-exchanges"> return policy</a>. You also
              agree that TUMAR will store some of your data to improve the
              quality of service the next time you shop on our site.
            </p>
            <button :class="{
              valid:
                isDeliveryInfoValid &&
                isPaymentInfoValid &&
                !errorMessage.length &&
                !nameErrorMessage.length,
            }" @click="() => onOrder(true)" class="place-order-btn">
              Place order
            </button>
            <button :class="{
              valid:
                isDeliveryInfoValid &&
                isPaymentInfoValid &&
                !errorMessage.length &&
                !nameErrorMessage.length,
            }" @click="() => onOrder(false)" class="place-order-btn mt-2" v-if="!isAuthenticated">
              Order without authorization
            </button>
          </div>
        </div>
      </section>
    </div>
    <AuthModal :isOpen="isLoginOpen" @close="isLoginOpen = false" :isUserExist="isUserExist"
      :paymentInfo="paymentInfo" />
  </main>
</template>
<script>
import axios from '@/core/services/api.service'
import { getImageName } from '@/utils/utils'

import { createNamespacedHelpers } from 'vuex'
import AuthModal from './AuthModal'

const { mapState: mapOrderState, mapActions: mapOrderActions } =
  createNamespacedHelpers('orderHistory')
const { mapState: mapCountryState, mapActions: mapCountryActions } =
  createNamespacedHelpers('country')
const { mapState: State_Artisan } = createNamespacedHelpers('artisan')
const { mapGetters: mapAuthGetters, mapActions: mapAuthActions } = createNamespacedHelpers('auth')

export default {
  name: 'Registration',
  components: {
    AuthModal,
  },
  data() {
    return {
      paymentInfo: {
        firstName: '',
        phone: '',
        email: '',
      },
      deliveryEnabled: false,
      deliveryInfo: {
        country: 236,
        address: '',
        // livingArea: '',
        district: '',
        mailIndex: '',
        inn: '',
      },
      additionalField: false,
      selectedPayment: 'kicb',
      order: [],
      errorMessage: '',
      nameErrorMessage: '',
      isLoginOpen: false,
      isUserExist: false,
      selectedDeliveryService: null,
    }
  },
  computed: {
    ...State_Artisan(['artisan']),
    ...mapOrderState(['deliveryPrice']),
    ...mapCountryState(['countriesList']),
    ...mapAuthGetters(['isAuthenticated']),
    isSpecialProduct() {
      return this.order.find((item) => item.isSpecialProduct)?.isSpecialProduct
    },
    isPaymentInfoValid() {
      const isEmpty = Object.values(this.paymentInfo).every(
        (value) => value !== ''
      )
      if (isEmpty) {
        return true
      } else {
        return false
      }
    },
    total() {
      return this.order.reduce((acc, curr) => {
        return (acc += curr?.size?.count * curr?.size?.price?.view)
      }, 0)
    },
    paymentMethods() {
      return [
        {
          label: 'Kyrgyz Investment And Credit Bank',
          value: 'kicb',
          image: '/img/visa-master-card.png',
          class: 'kicb_img',
        },
      ]
    },
    subtotal() {
      const deliveryPrice = this.selectedDeliveryService && this.deliveryPrice
        ? this.deliveryPrice.services.find((service) => service.id === this.selectedDeliveryService).price
        : this.deliveryPrice?.cost ? this.deliveryPrice.cost.delivery_view : 0;

      if (this.isSpecialProduct) {
        const price = this.order.reduce((acc, curr) => {
          return (acc += curr.product.sale_cost * curr.count)
        }, 0)

        return (price + deliveryPrice).toFixed(2)
      } else {
        const price = this.order.reduce((acc, curr) => {
          if (+curr?.size?.price.discount.view) {
            return (acc +=
              (curr?.size?.price?.view - curr?.size?.price?.discount?.view) *
              curr?.size?.count)
          } else {
            return (acc += curr?.size?.price?.view * curr?.size?.count)
          }
        }, 0)
        return (price + deliveryPrice).toFixed(2)
      }
    },
    isDeliveryInfoValid() {
      const isFilledExceptInn = Object.entries(this.deliveryInfo).every(
        ([key, value]) => {
          return key === 'inn' || value !== ''
        }
      )
      return isFilledExceptInn && (this.deliveryPrice?.cost || this.selectedDeliveryService)
    },
  },
  watch: {
    paymentInfo: {
      handler(val) {
        this.saveToLocalStorage('paymentInfo', val)
      },
      deep: true,
    },
    deliveryInfo: {
      handler(val) {
        this.saveToLocalStorage('deliveryInfo', val)
        this.additionalField = val.country === 'Россия'
      },
      deep: true,
    },
  },
  methods: {
    ...mapAuthActions(['isEmailExist']),
    getImageName,
    removeEmptyFields(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) => value !== '' && value != null)
      )
    },
    saveToLocalStorage(key, newData) {
      const oldData = JSON.parse(localStorage.getItem(key) || '{}')
      const cleanedNewData = this.removeEmptyFields(newData)
      const merged = { ...oldData, ...cleanedNewData }

      // Сохраняем только если есть хоть что-то
      if (Object.keys(merged).length > 0) {
        localStorage.setItem(key, JSON.stringify(merged))
      }
    },
    ...mapOrderActions([
      'createRetailOrder',
      'createSpecialProductOrder',
      'fetchDeliveryPrice',
      'payByPaypal',
      'payByKKB',
      'payByKICB'
    ]),
    ...mapCountryActions(['fetchCountriesList']),
    validatePhone() {
      const noLettersRegex = /^[^a-zA-Zа-яА-ЯёЁ]*$/

      if (!this.paymentInfo.phone || this.paymentInfo.phone?.length === 0) {
        this.errorMessage = ''
        return;
      }

      if (!noLettersRegex.test(this.paymentInfo.phone)) {
        this.errorMessage = 'Неверный формат номера'
      } else {
        this.errorMessage = ''
      }
    },
    validateName() {
      const { firstName, lastName } = this.getPaymentInfoName(this.paymentInfo.firstName);
      if(!this.paymentInfo.firstName || this.paymentInfo.firstName?.length <= 0) {
        this.nameErrorMessage = ''
        return;
      }
      
      if (firstName.trim().length <= 0 || lastName.trim().length <= 0) {
        this.nameErrorMessage = 'First name and Last name are required!'
      } else {
        this.nameErrorMessage = ''
      }
    },
    async getDeliveryPrice() {
      if (this.isSpecialProduct) {
        return
      }

      let result = {
        country_id: null,
        products: [],
      }
      result.country_id = this.deliveryInfo.country
      this.order.forEach((i) => {
        result.products.push({
          product_id: i?.size?.id,
          amount: i?.size?.count,
        })
      })
      this.fetchDeliveryPrice(result)
    },
    innInput(e) {
      if (e.target.value.length >= 11) {
        this.deliveryInfo.inn = e.target.value.substring(0, 12)
        return
      }
      this.deliveryInfo.inn = e.target.value
    },
    getPaymentInfoName(fullName) {
      const parts = fullName.trim().split(/\s+/);
      if (typeof fullName !== 'string' || parts.length === 0 || parts[0] === '') return { firstName: '', lastName: '' };

      const firstName = parts[0];
      const lastName = parts.slice(1).join(' ');
      return { firstName, lastName };
    },
    async onOrder(auth) {
      if (!this.isAuthenticated && auth) {
        const res = await this.isEmailExist(this.paymentInfo.email);
        if (res.status) this.isUserExist = true;
        this.isLoginOpen = true;
        return;
      }

      if (this.errorMessage || this.paymentInfo.phone.length === 0) {
        return
      }
      // if (!this.isDeliveryInfoValid && !this.isPaymentInfoValid) {
      //   return
      // }
      // localStorage.setItem('goBackLogin', JSON.stringify(this.$route.path))
      try {
        let payload = {}
        let userInfo = {}
        let products = []
        let body = {}
        userInfo.first_name = this.getPaymentInfoName(this.paymentInfo.firstName).firstName
        userInfo.last_name = this.getPaymentInfoName(this.paymentInfo.firstName).lastName
        userInfo.phone = this.paymentInfo.phone
        userInfo.email = this.paymentInfo.email
        userInfo.country_id = this.deliveryInfo.country
        userInfo.address = this.deliveryInfo.address
        userInfo.locality = String(this.deliveryInfo.country)
        userInfo.zip_code = this.deliveryInfo.mailIndex
        userInfo.wine_region = this.deliveryInfo.district
        userInfo.tax_number = 'tax_number'

        // payload for order special good
        payload.fname = this.getPaymentInfoName(this.paymentInfo.firstName).firstName
        payload.lname = this.getPaymentInfoName(this.paymentInfo.firstName).lastName
        payload.phone = this.paymentInfo.phone
        payload.email = this.paymentInfo.email
        payload.artisan_id = this.artisan.id
        payload.country_id = this.deliveryInfo.country
        payload.address = this.deliveryInfo.address
        // payload.settlement = this.deliveryInfo.livingArea
        payload.region = this.deliveryInfo.district
        payload.zip_code = this.deliveryInfo.mailIndex

        this.order.forEach((item) => {
          if (this.isSpecialProduct) {
            products.push({
              id: item.product.id,
              color_id: item.color.id,
              quantity: item.count,
              dimensions: [item.size],
              thickness: [item.thickness],
            })
          } else {
            products.push({
              product_id: item?.size?.id,
              amount: item?.size?.count,
              price_view: item?.size?.price?.view,
              price_raw: item?.size?.price?.raw,
              currency_id: item?.size?.currency?.currency?.id,
              discount: item?.size?.price?.discount,
            })
          }
        })

        payload['products'] = products

        if (this.isSpecialProduct) {
          const res = await this.createSpecialProductOrder(payload)

          const uuid = res.data.order_uuid
          const resHalPrice = await axios.post(
            `/specialgoods/order/${uuid}/halfPriceCheckout`
          )
          window.open(resHalPrice.data.redirect_url, '_blank')
        } else {
          const data = {
            customer: userInfo,
            products,
          };
          if (this.deliveryPrice?.cost) {
            data['delivery'] = {
              ...this.deliveryPrice.cost,
              currency: this.deliveryPrice.currency.code ?? this.order[0]?.size?.currency.currency.currency
            }
          } else data['delivery_service_id'] = this.selectedDeliveryService;
          const response = await this.createRetailOrder(data)
          if (response.status === 200) {
            if (this.selectedPayment === 'kkb') {
              const res = await this.payByKKB({
                order_id: response?.data?.order?.id,
              })
              if (res.status === 200) {
                window.open(res?.data?.redirect_url, '_blank')
              }
            } else if (this.selectedPayment === 'paypal') {
              const res = await this.payByPaypal({
                order_id: response?.data?.order?.id,
              })
              if (res.status === 200) {
                window.open(res?.data?.redirect_url, '_blank')
              }
            } else if (this.selectedPayment === 'kicb') {
              const res = await this.payByKICB({
                order_number: response?.data?.order?.order_number,
              })
              if (res.status === 200) {
                window.open(res?.data?.redirect_url, '_blank')
              }
            }
          }
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          this.isLoginOpen = true
        }
      }
    },
  },
  async created() {
    this.paymentInfo = JSON.parse(localStorage.getItem("paymentInfo")) || {
      firstName: '',
      phone: '',
      email: '',
    }
    this.deliveryInfo = JSON.parse(localStorage.getItem("deliveryInfo")) || {
      country: 236,
      address: '',
      district: '',
      mailIndex: '',
      inn: '',
    }

    await this.fetchCountriesList()
    if (this.$route.params.order?.length) {
      localStorage.setItem('retailOrder', JSON.stringify([]))
      this.order = this.$route.params.order
      localStorage.setItem(
        'retailOrder',
        JSON.stringify(this.$route.params.order)
      )
    } else {
      const storedOrder = localStorage.getItem('retailOrder')
      this.order = storedOrder ? JSON.parse(storedOrder) : []
    }
    if (this.deliveryInfo.address || this.deliveryInfo.country || this.deliveryInfo.district || this.deliveryInfo.mailIndex) {
      this.deliveryEnabled = true
      this.getDeliveryPrice();
    }
  },
  mounted() {
    this.validatePhone()
    this.validateName()
  }
}
</script>

<style lang="scss" scoped>
.payment__text a {
  font-size: 12px !important;
  text-decoration: underline !important;
}

.main {
  border: none;
}

.registration__input {
  &_error {
    border-color: red;
  }
}

.registration__delivery-info {
  select {
    position: relative;

    &:before {
      position: absolute;
      content: '^';
      right: 20px;
      top: 0;
    }

    // appearance: auto;
    padding-right: 30px;
  }
}

.payment_option {
  padding: 10px 15px;
  background: #f6f6f6;
  margin-right: 40px;
  border-radius: 5px;
  cursor: pointer;
}

.payment_option_active {
  background: #cfebcc;
}

.delivery-info {
  &__input-label {
    // font-family: 'Alegreya Sans';
    font-weight: 500;
    color: #423f3d;
  }

  &__input-required-sign {
    color: #ea6c6c;
  }
}

.place-order-btn {
  cursor: default;

  &.valid {
    background-color: #cfebcc;
    color: #666666;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.registration {
  &__delivery-info {
    #country {
      border: none;
    }

    .v-select__slot {
      border: 0.7px solid #dcdcdc;
      border-radius: 2px;
    }
  }

  .v-expansion-panel-content__wrap {
    padding: 0 15px 14px 27px !important;
  }

  .v-text-field>.v-input__control>.v-input__slot:before,
  .v-text-field>.v-input__control>.v-input__slot:after {
    content: none;
  }

  .v-text-field>.v-input__control>.v-input__slot:after {
    content: none;
  }

  .v-input input {
    max-height: unset;
  }

  .v-text-field input {
    padding: 10px 30px;
  }

  .v-select:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot>input {
    font-size: 14px;
    line-height: 15px;
  }
}

.v-autocomplete__content .v-select-list.v-list.v-sheet {
  background-color: #ffffff;
  border: 0.7px solid #dcdcdc;
}

img.paypal_img {
  width: 85px;
}

img.kkb_img {
  width: 42px;
}
</style>
